import { create } from 'zustand';
import type { GameState } from '@shared/types/game.types';
import type { Position } from '@shared/types/chess.types';

interface GameStore {
  gameState: GameState | null;
  selectedSquare: Position | null;
  legalMoves: Position[];
  isMyTurn: boolean;
  
  // Actions
  setGameState: (state: GameState) => void;
  selectSquare: (position: Position | null) => void;
  setLegalMoves: (moves: Position[]) => void;
  makeMove: () => void;
  updateMove: () => void;
  resetGame: () => void;
}

export const useGameStore = create<GameStore>((set, get) => ({
  gameState: null,
  selectedSquare: null,
  legalMoves: [],
  isMyTurn: false,
  
  setGameState: (state) => {
    console.log('[GameStore] Setting game state:', {
      status: state?.gameStatus,
      hasBoard: !!state?.board,
      currentTurn: state?.currentTurn,
      fullState: state
    });
    set({ gameState: state });
  },
  
  selectSquare: (position) => set({ selectedSquare: position }),
  
  setLegalMoves: (moves) => set({ legalMoves: moves }),
  
  makeMove: () => {
    // Move logic will be handled by socket service
    set({ selectedSquare: null, legalMoves: [] });
  },
  
  updateMove: () => {
    const { gameState } = get();
    if (!gameState) return;
    
    // Update will come from server
    set({ selectedSquare: null, legalMoves: [] });
  },
  
  resetGame: () => set({
    gameState: null,
    selectedSquare: null,
    legalMoves: [],
    isMyTurn: false,
  }),
}));